import { useT } from "../../src/translations";

import {
  GamingIcon,
  MetaIcon,
  ProgrammingIcon,
  RamblingsIcon,
} from "./MiddleIcons";

export type CategoryIconProps = {
  categoryName: string;
};

const categoryNameIcon = {
  gaming: <GamingIcon />,
  development: <ProgrammingIcon />,
  ramblings: <RamblingsIcon />,
  meta: <MetaIcon />,
};

export default function CategoryIcon({ categoryName }: CategoryIconProps) {
  const CorrespondingCategoryIcon =
    categoryNameIcon[categoryName.toLowerCase()];
  if (CorrespondingCategoryIcon) {
    return CorrespondingCategoryIcon;
  }
  return null;
}

export function CategoryIconAndName({ categoryName }: CategoryIconProps) {
  const t = useT();
  return (
    <>
      <CategoryIcon categoryName={categoryName} />
      {t.categories[categoryName]}
    </>
  );
}
